import * as React from "react";
import { cn } from "../../lib/utils";

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: SelectOption[];
  placeholder?: string;
  optionClassName?: string;
}

export function Select({
  className,
  optionClassName,
  options,
  placeholder,
  ...props
}: SelectProps) {
  return (
    <select
      className={cn(
        "bg-transparent text-sm font-medium cursor-pointer outline-none",
        className,
      )}
      {...props}
    >
      {placeholder && (
        <option value="" disabled className={optionClassName}>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option
          key={option.value}
          value={option.value}
          className={optionClassName}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
}

Select.displayName = "Select";
